import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    inboxData: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getApiConfigManagementInboxData = createAsyncThunk(
    "api-config-management/inbox",
    async ({ user, pagination }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.getMakerPendingApiConfig;
                apiURL = base + endpointpath + `/${pagination.pageSize}/${pagination.currentPage}`;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.getCheckerPendingApiConfig;
                apiURL = base + endpointpath + `/${pagination.pageSize}/${pagination.currentPage}`;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postAddedUpdateApiConfigReview = createAsyncThunk(
    "api-config-management/inbox/added-update-api-config-review",
    async ({ user, body }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.updateApiConfigMakerReviewTasks;
                apiURL = base + endpointpath;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.addCheckerApiConfig;
                apiURL = base + endpointpath;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.post(apiURL, body);

            if (response?.data?.responseCode === '400' || response?.data?.responseCode === '409') {
                toast.error(response?.data?.responseDescription);
                return { status: response?.data?.responseCode };
            }

            toast.success(body.isaccepted ? 'Request accepted and send successfully' : 'Request rejected and send successfully');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const ApiConfigManagementInboxSlice = createSlice({
    name: "api-config-management-inbox",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET ALL API CONFIG
            .addCase(getApiConfigManagementInboxData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getApiConfigManagementInboxData.fulfilled, (state, action) => {
                const { data, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.inboxData = data || [];
                state.pagination = { currentPage, pageSize, totalItem, totalPages }
            })
            .addCase(getApiConfigManagementInboxData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // ADD UPDATE API CONFIG REVIEW
            .addCase(postAddedUpdateApiConfigReview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postAddedUpdateApiConfigReview.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postAddedUpdateApiConfigReview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default ApiConfigManagementInboxSlice.reducer;